<route lang="json">
{ "name": "shop" }
</route>

<template>
  <div class="shop flex-column" :class="{ showingFilters: showFilters }">
    <DebugBlock>
      <div class="flex-row flex-align-center gap-sm">
        <Button class="grey" @click="addStaleItem()"> Add Stale Item </Button>
        <Button class="grey" @click="hackTimer(5000 + 5 * 1000 * 60)">
          5 Minute Timer
        </Button>
        <Button class="grey" @click="copyItemIds()"> Copy Item Ids </Button>
        <Button class="grey" @click="compareItemIds()">
          Compare Item Ids
        </Button>
        <div class="flex-column">
          <div>
            {{ shop.categories.length }} allowed /
            {{ shop.objects.categories.length }} total
          </div>
          <div>
            {{ products.length }} products / {{ shop.products.length }} allowed
            / {{ shop.objects.products.length }} total
          </div>
          <div>
            Firebase --<br />
            Products: {{ Object.keys(firebase.productsData).length }} / counts:
            {{ Object.keys(firebase.productsData).length }}
          </div>
        </div>
      </div>
      <div>
        <input type="datetime-local" v-model="lastSyncDt" />
      </div>
      <div class="flex-row">
        <Button class="grey" @click="testPatcher"> Test Patcher </Button>
        <Button class="grey" @click="testPatcher2">
          Test Patcher (w/Missing)
        </Button>
      </div>
      <div class="diff-products flex-row flex-left">
        <div class="grid5-auto gap-2xs-y gap-sm-x flex-static margin-auto">
          <template v-for="dp of diffProducts">
            <a
              :href="`https://paparazziaccessories.com/admin/paparazzi/item/${dp.id}/change/`"
              target="_blank"
            >
              {{ dp.id }}
            </a>
            <CopySnippet :text="dp.remote_id" />
            <CopySnippet :text="dp.slug" />
            <div>{{ dp.name }}</div>
            <div>{{ dp.release_date }}</div>
          </template>
        </div>
      </div>
    </DebugBlock>

    <RepBanner />

    <div class="products-cont flex-column">
      <div class="mobile-quick-add">
        <RouterLink v-if="user.isRep" :to="{ name: 'shop-quickadd' }">
          <Button class="grey">Quick Add</Button>
        </RouterLink>
      </div>
      <div class="flex-row flex-align-center flex-left gap-sm">
        <!-- <div class="flex-column flex-align-top flex-center gap-sm"> -->
        <a
          @click.prevent="showFilters = !showFilters"
          href="#"
          class="product-filter"
        >
          FILTER
          <i v-if="showFilters" class="pi pi-chevron-down" />
          <i v-else class="pi pi-chevron-right" />
        </a>
        <div v-if="categories.length === 1" class="flex-row gap-sm">
          <h1 v-for="category of categories" class="pa-h6">
            {{
              user.isRep ? category.name : category.retail_name || category.name
            }}
          </h1>
        </div>
        <div class="flex-stretch" />
        <RouterLink
          v-if="user.isRep"
          :to="{ name: 'shop-quickadd' }"
          class="desktop-quick-add"
        >
          <Button class="grey">Quick Add</Button>
        </RouterLink>
      </div>
      <div class="product-content flex-row gap-sm">
        <div
          v-if="showFilters"
          @click.prevent="showFilters = false"
          class="backdrop"
        />
        <div v-if="showFilters" class="filters flex-static flex-column gap-xs">
          <!-- <InputGroup>
            <InputText type="search" placeholder="Search..." v-model="search" />
            <InputGroupAddon>
              <i class="pi pi-search"></i>
            </InputGroupAddon>
          </InputGroup> -->
          <BasicTree
            v-model:selectionKeys="selected"
            :value="tree"
            :debugShowVisibility="user.isDev"
          />
          <BasicTree
            v-model:selectionKeys="selectedMetals"
            :value="metalTree"
          />
          <BasicTree
            v-model:selectionKeys="selectedColors"
            :value="colorTree"
          />
        </div>
        <div class="flex-column flex-stretch" :class="selected">
          <ShopJoinTracker />
          <DebugBlock v-if="categories.length > 0">
            <div class="flex-column justify-left align-left">
              <div v-for="category of categories" class="category-debug">
                <Accordion :key="category.id">
                  <AccordionTab :header="category.name">
                    <div class="flex-row flex-left">
                      <div class="grid2-auto flex-static gap-sm-x">
                        <div>Active:</div>
                        <div>{{ category.active }}</div>
                        <div>Indexed:</div>
                        <div>{{ category.indexed }}</div>
                        <div>Allow All:</div>
                        <div>{{ category.allow_all }}</div>
                        <div>Allowed Groups:</div>
                        <div>{{ category.allowed_groups.join(", ") }}</div>
                        <div>Your Groups:</div>
                        <div>{{ user.groups.join(", ") }}</div>
                        <div>Active Products:</div>
                        <div>{{ shop.counts[category.id] }}</div>
                        <div>Release Dates:</div>
                        <div>{{ category.release_date }}</div>
                      </div>
                    </div>
                  </AccordionTab>
                  <AccordionTab :header="`${category.name} &gt; Products`">
                    <div class="flex-row flex-left">
                      <div class="grid4-auto flex-static gap-sm-x">
                        <div>Product</div>
                        <div>Active</div>
                        <div>Parent</div>
                        <div>Stock:</div>
                        <template
                          v-for="product of shop.objects.products.filter((p) =>
                            p.categories.includes(category.id),
                          )"
                        >
                          <b>{{ product.name }}</b>
                          <div>{{ product.active }}</div>
                          <div>{{ product.parent }}</div>
                          <div class="text-right">{{ product.stock }}</div>
                        </template>
                      </div>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>
            </div>
          </DebugBlock>
          <div class="flex-row flex-center">
            <Message v-if="firebase.error" type="warning">
              <div class="p-2xs">
                Sorry we are having trouble loading our products. Please refresh
                your page.<br /><br />

                If the error continues please contact
                <a href="mailto: it@paparazziaccessories.com" target="_blank">
                  it@paparazziaccessories.com
                </a>
              </div>
              <div class="pa-p1b p-2xs m-sm-b">{{ firebase.error }}</div>
              <Button @click.prevent="tryReload">Reload</Button>
            </Message>
            <span v-else-if="!shop.isReady"><!-- not showing loading --></span>
            <Message v-else-if="searching" type="info"> Searching... </Message>
            <Message v-else-if="products.length === 0" type="warning">
              Sorry, it looks like there aren’t any accessories that match your
              search. <br />
              Please check your filters and try again.
            </Message>
          </div>
          <div
            v-if="
              !firebase.error &&
              !shop.isReady &&
              preFilteredProducts.length === 0
            "
            class="products"
            :class="{ 'sidebar-open': showFilters }"
          >
            <template v-for="result of 10">
              <LoadingProductBlock />
            </template>
          </div>
          <div v-else class="products" :class="{ 'sidebar-open': showFilters }">
            <template v-for="result of products.slice(0, max)">
              <ProductBlock :object="result" :back="back" />
            </template>
            <ScrollIndicator
              :screens="2"
              @bottom="max = Math.min(max + 20, products.length)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BasicTree from "@/components/BasicTree.vue";
import CopySnippet from "@/components/CopySnippet.vue";
import DebugBlock from "@/components/DebugBlock.vue";
import ScrollIndicator from "@/components/ScrollIndicator.vue";
import ShopJoinTracker from "@/components/join/ShopJoinTracker.vue";
import RepBanner from "@/components/rep/RepBanner.vue";
import LoadingProductBlock from "@/components/shop/LoadingProductBlock.vue";
import ProductBlock from "@/components/shop/ProductBlock.vue";

import {
  colorOptions,
  metalOptions,
  type Category,
  type Product,
} from "@/stores/defs/shop_defs";
import { useFirebaseStore } from "@/stores/firebase";
import { useShopStore } from "@/stores/shop";
import { useToasterStore } from "@/stores/toaster";
import { useUserStore } from "@/stores/user";
import { useWindowStore } from "@/stores/window";
import { cancelDebounce, debounce } from "@/utils/bouncer";
import { useHead } from "@unhead/vue";
import Fuse from "fuse.js";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Button from "primevue/button";
import Message from "primevue/message";
import type { TreeNode } from "primevue/treenode";
import sortBy from "sort-by";
import type { Ref } from "vue";
import { computed, nextTick, onMounted, ref, toRef, watch } from "vue";
import { useRoute, useRouter, type RouteLocationRaw } from "vue-router";

interface ProductWithCategoryNames extends Product {
  categoryNames?: string;
}

const emits = defineEmits(["update:path"]);
const props = defineProps<{
  path?: string;
}>();
const shop = useShopStore();
const router = useRouter();
const route = useRoute();
const user = useUserStore();
const firebase = useFirebaseStore();
const toaster = useToasterStore();
const windowStore = useWindowStore();

const max = ref(30);
const showFilters = ref(false);
const products: Ref<Product[]> = ref([]);
const diffProducts = ref<Product[]>([]);
const searching = ref<boolean>(false);

const fuse = new Fuse<ProductWithCategoryNames>([], {
  distance: 1000,
  threshold: 0.15,
  keys: ["name", "description", "remote_id", "categoryNames"],
});
const metalTree: TreeNode[] = [
  {
    key: "metal",
    label: "Metal Color",
    children: metalOptions,
  },
];
const colorTree: TreeNode[] = [
  {
    key: "color",
    label: "Color",
    children: colorOptions,
  },
];

const lastSyncDt = computed({
  get: () => {
    const retval = firebase.lastSync.products;
    if (retval && /Z$/.test(retval)) {
      return retval.replace(/Z$/, "");
    }
    return retval;
  },
  set: (v) => {
    firebase.lastSync.products = new Date(v).toISOString();
  },
});

const back = computed(() => {
  if (searchText.value || parts.value.length > 0) {
    return route.fullPath;
  }
  return undefined;
});

const parts: Ref<string[]> = computed({
  get: () => {
    return props.path ? props.path.split("/") : [];
  },
  set: (v: string[]) => {
    if (v.length === 0) {
      const route: RouteLocationRaw = { name: "shop" };
      if (searchText.value) {
        route.query = { search: searchText.value };
      }
      router.push(route);
      emits("update:path", null);
    } else {
      const path = v.join("/");
      let route = `/shop/${path}`;
      if (searchText.value) {
        route += `?search=${searchText.value}`;
      }
      router.push(route);
      emits("update:path", path);
    }
  },
});
const selected: Ref<string[]> = computed({
  get: () => {
    const mine = parts.value
      .filter((p) => !/:/.test(p))
      .filter((p) => {
        if (user.isDev) {
          return true;
        } else {
          return p === "new" || shop.categories.find((c) => c.slug === p);
        }
      });
    return mine;
  },
  set: (v) => {
    updatePath({ selected: v });
  },
});
const selectedColors: Ref<string[]> = computed({
  get: () => {
    return parts.value
      .filter((p) => /^color:/.test(p))
      .map((p) => p.slice(6))
      .filter((p) => {
        return colorOptions.find((c) => c.key === p);
      });
  },
  set: (v) => {
    updatePath({ selectedColors: v });
  },
});
const selectedMetals: Ref<string[]> = computed({
  get: () => {
    return parts.value
      .filter((p) => /^metal:/.test(p))
      .map((p) => p.slice(6))
      .filter((p) => {
        return metalOptions.find((c) => c.key === p);
      });
  },
  set: (v) => {
    updatePath({ selectedMetals: v });
  },
});
const selectedColorsAndMetals: Ref<string[]> = computed(() => {
  return [...selectedColors.value, ...selectedMetals.value];
});

const searchText = computed(() => {
  for (const path of parts.value) {
    if (path.startsWith("search:")) {
      return path.slice(7);
    }
  }

  // get from query string
  if (router.currentRoute.value.query?.search) {
    return "" + router.currentRoute.value.query.search;
  }
  return "";
});

const listExcludedCategoryIds = computed(() => {
  const names = ["Consultant Exclusive"];
  if (!user.isLocalhost) {
    names.push("test");
  }
  let retval: number[] = [];
  for (const name of names) {
    const cat = shop.categories.find((c) => c.name === name);
    if (cat) {
      retval.push(cat.id);
      retval = retval.concat(shop.descendents[cat.id].map((c) => c.id));
    }
  }
  return retval;
});
const defaultCategoryIds = computed(() => {
  const allIds = shop.categories.map((c) => c.id);
  return allIds.filter((cid) => !listExcludedCategoryIds.value.includes(cid));
});

const categories = computed(() => {
  // show all categories for developers
  if (user.isDev) {
    return shop.objects.categories.filter((c: Category) =>
      selected.value.includes(c.slug),
    );
  }
  // show only allowed categories otherwise
  return shop.categories.filter((c: Category) =>
    selected.value.includes(c.slug),
  );
});
const categoryIds = computed(() => {
  let retval = [] as Category[];
  const ids = categories.value.map((c: Category) => c.id);
  for (const category of categories.value) {
    if (!category.parent) {
      const descendents = (shop.descendents[category.id] || []).slice();
      if (
        !descendents.some((c) => c.id !== category.id && ids.includes(c.id))
      ) {
        // add all subcategories
        retval = retval.concat(descendents);
        // } else {
        //   retval.push(category);
      }
    } else {
      retval.push(category);
    }
  }
  return retval.map((c) => c.id);
});
const tree = computed(() => {
  const dev = user.isDev;
  function getNode(category: Category): TreeNode {
    let label = user.isRep
      ? category.name
      : category.retail_name || category.name;
    return {
      key: category.slug,
      label: `${label}`,
      children: getChildren(category),
      data: category.id,
      allowed: !!shop.categories.find((c) => c.id === category.id),
      visible: shop.counts[category.id] > 0,
    };
  }
  function getChildren(category: Category): TreeNode[] {
    const root = dev ? shop.objects.categories : shop.categories;

    return root
      .filter((c) => {
        return (
          c.parent === category.id && (user.isDev || shop.counts[c.id] > 0)
        );
      })
      .map(getNode);
  }
  const retval = getNode({
    // @ts-ignore
    id: null,
    slug: "all",
    name: "Type",
  });
  return [retval];
});

const preFilteredProducts = ref<ProductWithCategoryNames[]>([]);

watch(
  [
    toRef(shop, "products"),
    toRef(shop, "ancestors"),
    toRef(windowStore, "visibility"),
    selected,
    categoryIds,
    searchText,
    selectedColorsAndMetals,
  ],
  () => {
    getPreFilteredProducts();
  },
);

watch(preFilteredProducts, async () => {
  if (await debounce("update-search-products")) {
    fuse.setCollection(preFilteredProducts.value as never[]);
  }
});

watch([searchText, preFilteredProducts], performSearch);

watch(
  () => shop.products,
  async () => {
    if (await debounce("refresh-search-products", 5000)) {
      fuse.setCollection(shop.products);
    }
  },
);

const titleContent: Record<string, string> = {
  necklaces: "Shop Necklaces",
  earrings: "Shop Earrings",
  bracelets: "Shop Bracelets",
  rings: "Shop Rings",
  anklets: "Shop Anklets",
  "hair-accessories": "Shop Hair Accessories",
  blockbusters: "Shop Blockbusters",
};
const descriptionContent: Record<string, string> = {
  necklaces:
    "Adorable, affordable, and always NEW! Shop the latest necklaces—new styles added daily!",
  earrings:
    "Adorable, afforable, and always NEW! Shop the latest earrings-new styles added daily!",
  bracelets:
    "Adorable, afforable, and always NEW! Shop the latest bracelets-new styles added daily!",
  rings:
    "Adorable, afforable, and always NEW! Shop the latest rings-new styles added daily!",
  anklets:
    "Adorable, afforable, and always NEW! Shop the latest anklets-new styles added daily!",
  "hair-accessories":
    "Adorable, afforable, and always NEW! Shop the latest hair accessories-new styles added daily!",
  blockbusters:
    "Adorable, afforable, and always NEW! Shop the latest jewelry-new styles added daily!",
};

useHead({
  title: () =>
    titleContent[props.path ?? ""] ?? "Shop Jewelry Trends for Every Occasion",
  meta: () => {
    const content =
      descriptionContent[props.path ?? ""] ??
      "Adorable, affordable, and always NEW! Shop the latest jewelry—new styles added daily!";
    return [
      {
        name: "description",
        content,
      },
    ];
  },
});

onMounted(async () => {
  if (parts.value.length > 0) {
    showFilters.value = true;
  }
  await getPreFilteredProducts();

  fuse.setCollection(preFilteredProducts.value as never[]);
  await performSearch();
});

async function getPreFilteredProducts() {
  if (
    windowStore.visibility &&
    (await debounce("getPreFilteredProducts", 100))
  ) {
    let retval: ProductWithCategoryNames[] = shop.products;

    // filter active only
    // inactive products might be fetched with the backup api method
    retval = retval.filter((p) => p.active);

    // const now = new Date(shop.lastUpdate.products);
    const now = new Date();

    if (selected.value.includes("new")) {
      const cutoff = new Date(now.getTime() - 1000 * 60 * 60 * 24 * 10);
      retval = retval.filter((p) => new Date(p.date_added) > cutoff);
    }

    if (categoryIds.value.length > 0) {
      retval = retval.filter((product) =>
        product.categories.some((cid) => categoryIds.value.includes(cid)),
      );
    } else if (!searchText.value) {
      retval = retval.filter((product) =>
        defaultCategoryIds.value.includes(product.category),
      );
    }

    if (selectedColorsAndMetals.value.length > 0) {
      retval = retval.filter((product) =>
        selectedColorsAndMetals.value.some((color) => {
          const category = getColorCategory(color);
          return (
            // (product.colors && product.colors.includes(color)) ||
            category && product.categories.includes(category.id)
          );
        }),
      );
    }

    // deployed is the date that the a timed product is released, or the date the product was added
    retval = retval.sort(sortBy("-deployed", "id"));
    retval.forEach((product) => {
      const categories = product.categories
        .map((c) => shop.ancestors[c])
        .flat()
        .filter((a) => a);
      const names = categories
        .map((c) => c.name)
        .filter((name) => !["Color"].includes(name));
      product.categoryNames = names.join(", ");
    });
    preFilteredProducts.value = retval;
  }
}

function tryReload() {
  location.reload();
}

function getColorCategory(color: string): Category | null {
  const colorObj =
    colorOptions.find((c) => c.key === color) ||
    metalOptions.find((c) => c.key === color);
  let category = null;
  if (colorObj) {
    category =
      shop.objects.categories.find(
        (c) =>
          (c.parent === shop.metalParent?.id ||
            c.parent === shop.colorParent?.id) &&
          new RegExp(colorObj.label).test(c.name),
      ) || null;
  }
  return category;
}

async function updatePath(updates: { [index: string]: string[] }) {
  const categories = updates.selected || selected.value;
  const colors = updates.selectedColors || selectedColors.value;
  const metals = updates.selectedMetals || selectedMetals.value;
  const retval: string[] = ([] as string[]).concat(
    categories,
    colors.map((c) => `color:${c}`),
    metals.map((c) => `metal:${c}`),
  );
  parts.value = retval;
}

async function performSearch() {
  searching.value = true;
  if (searchText.value) {
    if (await debounce("product-search")) {
      const results = fuse.search(searchText.value).map((a) => a.item);
      products.value = results;
      await nextTick();
      searching.value = false;
    }
  } else {
    cancelDebounce("product-search"); // clears previous attempt
    products.value = preFilteredProducts.value;
    searching.value = false;
  }
}

async function hackTimer(ms: number) {
  for (let x = 0; x < 4 * 2; x += 1) {
    const index = 4 + x;
    products.value[index].release_date = new Date(
      Date.now() + ms,
    ).toISOString();
  }
}

async function addStaleItem() {
  const old: Product = {
    id: 71844,
    remote_id: "P5PO-BNXX-044YR",
    name: "Cascading Class - Brown",
    description:
      '<P> A mismatched collection of various highly faceted topaz, light peach, tea, and light topaz gems is linked together in elegant succession as they glamorously cascade below the ear. Earring attaches to a standard post fitting. </P>  \n\n<P> <I> Sold as one pair of post earrings.  </I>  </P>\n\n<img src="https://d9b54x484lq62.cloudfront.net/paparazzi/shopping/images/517_tag150x115_1.png" alt="New Kit" align="middle" height="50" width="50"/>\n\n<br><b>\nGet The Complete Look!\n</b>\n<br>Necklace: "Gallery Gala - Brown" (Sold Separately)<br><br>',
    prices: { wholesale: 2.75, null: 5 },
    category: 3,
    volume: "2.00",
    active: true,
    images: [
      {
        original: "~/p/77829_1-8x10_1.jpg",
        "25_cropped": "~/tp/77829_1-8x10_1.jpg[c25]",
        "100_cropped": "~/tp/77829_1-8x10_1.jpg[c100]",
        "512_cropped": "~/tp/77829_1-8x10_1.jpg[c512]",
        w125: "~/tp/77829_1-8x10_1.jpg.125x200_q85.jpg",
        w250: "~/tp/77829_1-8x10_1.jpg.250x400_q85.jpg",
        w500: "~/tp/77829_1-8x10_1.jpg.500x800_q85.jpg",
        xxs: "~/tp/77829_1-8x10_1.jpg.240x240_q85.jpg",
        xs: "~/tp/77829_1-8x10_1.jpg[xs]",
      },
      {
        original: "~/p/77829_2-8x10_1.jpg",
        "25_cropped": "~/tp/77829_2-8x10_1.jpg[c25]",
        "100_cropped": "~/tp/77829_2-8x10_1.jpg[c100]",
        "512_cropped": "~/tp/77829_2-8x10_1.jpg[c512]",
        w125: "~/tp/77829_2-8x10_1.jpg.125x200_q85.jpg",
        w250: "~/tp/77829_2-8x10_1.jpg.250x400_q85.jpg",
        w500: "~/tp/77829_2-8x10_1.jpg.500x800_q85.jpg",
        xxs: "~/tp/77829_2-8x10_1.jpg.240x240_q85.jpg",
        xs: "~/tp/77829_2-8x10_1.jpg[xs]",
      },
      {
        original: "~/p/77829_comp-8x10_1.jpg",
        "25_cropped": "~/tp/77829_comp-8x10_1.jpg[c25]",
        "100_cropped": "~/tp/77829_comp-8x10_1.jpg[c100]",
        "512_cropped": "~/tp/77829_comp-8x10_1.jpg[c512]",
        w125: "~/tp/77829_comp-8x10_1.jpg.125x200_q85.jpg",
        w250: "~/tp/77829_comp-8x10_1.jpg.250x400_q85.jpg",
        w500: "~/tp/77829_comp-8x10_1.jpg.500x800_q85.jpg",
        xxs: "~/tp/77829_comp-8x10_1.jpg.240x240_q85.jpg",
        xs: "~/tp/77829_comp-8x10_1.jpg[xs]",
      },
    ],
    release_date: "2024-09-30T19:00:00+00:00",
    stock: 300,
    categories: [433, 3, 514, 509, 478, 507, 482],
    is_parent: false,
    subproducts: [],
    date_added: new Date().toISOString(),
    colors: ["BN"],
    inventory_source: "default",
    slug: "cascading-class-brown",
    deployed: new Date(),
    parent: 0,
    complete_look: [],
    cl_refs: [],
    extras: {},
    videos: [],
  };
  shop.objects.products.push(old);
  shop.patchers.products.cache.setItem(`${old.id}`, old);
}

function copyItemIds() {
  const ids = JSON.stringify(shop.objects.products.map((p) => p.id));
  // copy value to the clipboard using navigator api
  navigator.clipboard.writeText(ids);
  toaster.add({ summary: "Copied to clipboard" });
}

async function compareItemIds() {
  // read from the clipboard and compare product database to find the differences between the list
  const myProductIds = shop.objects.products.map((p) => p.id);
  const clipboardProductIds = JSON.parse(await navigator.clipboard.readText());
  const diff = myProductIds.filter((id) => !clipboardProductIds.includes(id));

  diffProducts.value = diff
    .map((id) => shop.objects.products.find((p) => p.id == id))
    .filter((a) => a) as Product[];
}

async function testPatcher() {
  // remove random product that current exists
  const randoIndex = Math.floor(Math.random() * shop.products.length);
  const rando = shop.products[randoIndex];
  shop.products.splice(randoIndex, 1);
  const products = shop.getPatcher("products");
  products.patch(rando.slug, { timestamp: new Date() });
}

async function testPatcher2() {
  // attempt to patch a product that doesn't exist
  const products = shop.getPatcher("products");
  products.patch("nothing", { timestamp: new Date() });
}
</script>

<style scoped>
.shop {
  gap: var(--md, 32px);
}

.p-dropdown {
  border: none;
}

.p-inputtext {
  padding: var(--XS, 16px) var(--2XS, 8px);
}

a.product-filter:hover {
  font-weight: 400;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  /* transition: font-weight 0.5s ease; */
  text-shadow: 0.75px 0 black;
}

.backdrop {
  display: none;
}
.filters {
  width: 185px;
  padding: 16px;
}
.p-tree {
  border: none;
  padding: 0;
}
.filters :deep(.p-treenode-content) {
  padding: 0;
  font-size: 14px;
}
.filters :deep(.p-link) {
  margin: 0;
}
.filters :deep(.p-checkbox),
.filters :deep(.p-checkbox .p-checkbox-box) {
  width: 15px;
  height: 15px;
}
.filters :deep(.p-checkbox) {
  margin: 0;
  display: inline-block;
}
.filters :deep(.p-checkbox .p-checkbox-box) {
  margin: 0;
  border-radius: 50%;
}

.filters :deep(.name) {
  padding: 11px var(--2XS, 8px) 10px 0;
  gap: var(--XS, 16px);
  text-wrap: pretty;
  text-shadow: none;
  -webkit-transition: all 0.1s;
  -moz-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;
  font-weight: 400;
}

.filters :deep(.name:hover) {
  text-shadow: 0.25px 0 black;
  font-weight: 400;
}

.filters :deep(.children) {
  padding: 0 0 0 var(--2XS, 8px);
  margin-left: 0;
}

.filters :deep(.children) a.name {
  padding: 8px 0;
}

.filters :deep(.children) .children {
  padding-left: 11px;
}

.filters :deep(.children) a.child:hover {
  font-weight: 400;
}

.products-cont {
  gap: var(--Sm);
}
.products {
  display: grid;
  gap: var(--1XL, 64px) var(--Sm, 24px);
  grid-template-columns: repeat(4, 1fr);
}

.product-block {
  position: relative;
  flex: 1 1 auto;
  min-width: 100px;
  max-width: 262px;
  font-size: 14px;
  img {
    aspect-ratio: 8 / 10;
  }
}

.shopping-with {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

i.pi-chevron-right,
.filters :deep(i.pi-chevron-right) {
  font-size: 9px;
  padding: 5px 8px;
}

i.pi-chevron-down,
.filters :deep(i.pi-chevron-down) {
  font-size: 9px;
  padding: 5px 8px;
}

.filters :deep(.children i.pi-chevron-right),
.filters :deep(.children i.pi-chevron-down) {
  display: none;
}

.mobile-quick-add {
  display: none;
}

/** hack to make the complete collection first */
.blockbusters .complete-blockbuster-collection-2087 {
  order: -1;
}

.pa-h6 {
  margin: 0;
}

@media (max-width: 1139px) and (min-width: 801px) {
  .products-cont {
    padding: 0 var(--Sm, 24px);
  }
  .product-block {
    max-width: 100%;
  }
}

@media (max-width: 900px) and (min-width: 801px) {
  .products.sidebar-open {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 800px) {
  .products-cont {
    padding: 0;
    gap: var(--XS, 16px);
  }
  .products {
    grid-template-columns: repeat(2, 1fr);
    row-gap: var(--XMd, 40px);
    margin: 0 auto;
  }
  .flex-row.flex-align-center.flex-left.gap-sm {
    gap: var(--2XS, 8px);
  }
  a.product-filter {
    font-size: 14px;
    font-weight: 300;
  }
  h1.pa-h6 {
    font-size: 14px;
    font-weight: 300;
  }
  #app .filters,
  #app .backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1001;
  }
  .filters {
    z-index: 2;
    background: white;
    overflow: auto;
    width: 220px;
  }
  #app .backdrop {
    display: block;
    background: rgba(0, 0, 0, 0.25);
  }
  .filters :deep(.children) {
    padding: 0 var(--XS, 16px);
  }
  .filters :deep(a.child) {
    padding: 16px 0;
  }
  .mobile-quick-add {
    display: flex;
    justify-content: right;
  }
  .desktop-quick-add {
    display: none;
  }
  .product-content {
    margin-top: 24px;
  }
}
</style>
